
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Senior Consultant (Research and Development)
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Educational Qualification: </h3>
              <p> A relevant bachelor's or master's degree in a 
                technical field such as engineering, 
                Technology and science or any other field 
                related to the subject matter of the technical 
                books.</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Eligibility Criteria: </h3>
              <p> For Graduate min 5 years of 
                experience <br>
                For Post graduate min 3-5 years 
                experience <br>
                <b>Academic Experience</b>. 
                Experience in educational settings, such as 
                faculty in engineering, Technology and science or 
                developing curriculum for practical and 
                theoretical domain. Minimum 2 to 3 years 
                Relevant Experiences must <br>
                <b>Professional Experience:</b> 
                Substantial industry experience required for 
                deep understanding of the subject matter 
                Must have working experiences as an 
                engineer, researcher, or in a leadership
                position in a technical field. Minimum 2 to 3 
                years Relevant Experiences must. 
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Job requirement: </h3>
              <p><span class="step_no">1</span> Developing and executing-new 
                product development projects. </p>
                <p><span class="step_no">2</span>collaborates with the team to bring the Quality Output based on the requirement.</p>
                <p><span class="step_no">3</span>Responsible for leading the R&D team, assigning work to the team and monitoring the responsibilities and their performance.</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 60,000/- to Rs. 70,000/- per month. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 23th June 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key Responsibility:</h3>
		
        <p> <span class="step_no">1</span><b>Writing and Communication Skils:</b><br> 
            Strong writing and speaking skills required to 
            effectively communicate complex technical 
            concepts in a clear and accessible manner to 
            the team members. Conducting training and 
            orientation to the external members </p>
        <p> <span class="step_no">2</span><b>Knowledge of Pedagogy</b><br> Understanding of pedagogical principles and 
            instructional design methodologies is crucial 
            for developing _ effective learning materials Experience in Instructional Material Designing 
            or books</p>
        <p> <span class="step_no">3</span><b>Curriculum Development Skills</b><br>Must have Experience in designing and 
            developing educational curricula, learning 
            objectives, and assessments.</p>
        <p><span class="step_no">4</span><b>Networking</b><br>A strong professional network in the technical 
            field can be advantageous . This network 
            required for collaboration, access to subject 
            matter experts, and potential authors </p>
        <p><span class="step_no">5</span><b>Adaptability</b><br>The ability to adapt to changes in technology 
            and the publishing landscape is important. 
            Collaborate with Institutes and industries to 
            ensure the contents as per the 
            requirements/needs.</p>
        <p><span class="step_no">6</span><b>Quality control</b><br>Conducting survey by designing the question 
            to level of Institutes running the trades,
            trainees and general users for getting the 
            specific feed backs. And updating the contents 
            with latest standards and technologies  
            applied/suitable for the particular trade</p>
			



      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
		
                  <p> <span class="step_no">1</span>Excellent writing and communication skills</p>
        <p> <span class="step_no">2</span>Strong analytical and documentation skills</p>
        <p> <span class="step_no">3</span>Experience of using automated accounting applications and MS Office</p>
			

        <p> <span class="step_no">4</span>Strong presentation skills and interpersonal skills</p>

		 <p> <span class="step_no">5</span>Should be able to operate in unstructured environment with minimal support.</p>
 <p> <span class="step_no">6</span>Openness to travel if required</p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>11 Months (extendable)</p>

           

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

 <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>Chennai </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Division</h3>
       		<p>Reaseach and Development</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>

